import ENV from "@/utils/env";
import { api } from "@/lib/api";
import { Category } from "./types/category.type";

/* Request Types */
export type StudyType = "asset" | "scene";

/* Response Types */
export interface CategoriesResp {
  payload: {
    useCaseCategories: Category[];
  };
}

/**
 * getCategories endpoint
 *
 * Get all use cases and their categories for an account.
 * Different accounts may have different categories and use cases.
 *
 * @param studyType - Optional filter for "asset" or "scene" categories. Defaults to "asset" on backend.
 */
export const getCategories = async (studyType?: StudyType) => {
  const params = studyType ? { studyType } : {};
  const resp = await api.get(`${ENV.API_PLATFORM_URL}/manage/account/usecasecategories`, { params });
  return resp.data as CategoriesResp;
};
